function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ResultTemplate = require('./result.template');
var Result = /*#__PURE__*/function () {
  function Result(app, mod) {
    _classCallCheck(this, Result);
    this.app = app;
    this.mod = mod;
    this.countdown_timer = null;
    this.deadline = 0;
  }
  return _createClass(Result, [{
    key: "render",
    value: function render() {
      if (!this.mod.gameBrowserActive() && !this.mod.browser_active) {
        return;
      }
      if (!document.querySelector('.poker-result')) {
        this.app.browser.addElementToSelector(ResultTemplate(), '.poker-table');
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _this = this;
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render();
      var host = document.getElementById('poker-result');
      if (!host) {
        return;
      }
      var cards_el = document.getElementById('poker-result-cards');
      var headline_el = document.getElementById('poker-result-headline');
      var hand_el = document.getElementById('poker-result-hand');
      var cards = Array.isArray(opts.cards) ? opts.cards.filter(Boolean) : [];
      if (cards_el) {
        cards_el.innerHTML = cards.map(function (card) {
          var name = String(card).replace(/\.png$/i, '');
          return "<img class=\"card\" src=\"".concat(_this.mod.card_img_dir, "/").concat(name, ".png\" alt=\"\">");
        }).join('');
        cards_el.hidden = cards.length === 0;
      }
      if (headline_el) {
        headline_el.textContent = opts.headline || '';
      }
      if (hand_el) {
        hand_el.textContent = opts.hand || '';
        hand_el.hidden = !opts.hand;
      }
      host.hidden = false;
      host.classList.add('is-visible');
    }
  }, {
    key: "hide",
    value: function hide() {
      this.clearCountdown();
      this.clearAcknowledge();
      var host = document.getElementById('poker-result');
      if (host) {
        host.classList.remove('is-visible');
        host.hidden = true;
      }
      var cards_el = document.getElementById('poker-result-cards');
      if (cards_el) {
        cards_el.innerHTML = '';
      }
    }
  }, {
    key: "clearAcknowledge",
    value: function clearAcknowledge() {
      var el = document.getElementById('controls');
      if (el && el.closest('.poker-result')) {
        el.innerHTML = '';
      }
    }

    // Bind the displayed countdown to the same deadline as setShotClock.
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      var _this2 = this;
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Result.ACKNOWLEDGE_MS;
      this.clearCountdown();
      this.deadline = Date.now() + ms;
      this.tickCountdown();
      this.countdown_timer = setInterval(function () {
        return _this2.tickCountdown();
      }, 200);
    }
  }, {
    key: "tickCountdown",
    value: function tickCountdown() {
      var el = document.getElementById('poker-result-countdown');
      if (!el || !this.deadline) {
        return;
      }
      var remaining = Math.ceil((this.deadline - Date.now()) / 1000);
      if (remaining <= 0) {
        el.textContent = '';
        this.clearCountdown();
        return;
      }
      el.textContent = "Next hand in ".concat(remaining);
    }
  }, {
    key: "clearCountdown",
    value: function clearCountdown() {
      if (this.countdown_timer) {
        clearInterval(this.countdown_timer);
        this.countdown_timer = null;
      }
      this.deadline = 0;
    }
  }, {
    key: "formatHandName",
    value: function formatHandName(name) {
      return String(name || '').replace(/-/g, ' ').replace(/\b\w/g, function (ch) {
        return ch.toUpperCase();
      });
    }
  }]);
}();
// Authoritative auto-acknowledge duration. Shot clock and display share this.
_defineProperty(Result, "ACKNOWLEDGE_MS", 3000);
module.exports = Result;